import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Paprika, PaprikaRadius } from '../../styles/theme';
import { categoryIcon } from './categoryMeta';
import { PantryIcon } from './PantryIcon';

interface Props {
  category: string;
  name?: string;
  size?: number;
  radius?: number;
}

export function FoodTile({ category, name = '', size = 40, radius = PaprikaRadius.sm }: Props) {
  const icon = categoryIcon(category, name);

  return (
    <View style={[styles.tile, { width: size, height: size, borderRadius: radius }]}>
      <PantryIcon icon={icon} size={size * 0.5} color={Paprika.textPrimary} />
    </View>
  );
}

const styles = StyleSheet.create({
  tile: {
    backgroundColor: Paprika.foodTile,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: Paprika.hairline,
  },
});
